import createIcon from '../../createIcon';

/**
 * @component @name HourglassEmpty
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyVjhINi4wMUw2IDguMDFMMTAgMTJMNiAxNkw2LjAxIDE2LjAxSDZWMjJIMThWMTYuMDFIMTcuOTlMMTggMTZMMTQgMTJMMTggOC4wMUwxNy45OSA4SDE4VjJINlpNMTYgMTYuNVYyMEg4VjE2LjVMMTIgMTIuNUwxNiAxNi41Wk0xMiAxMS41TDggNy41VjRIMTZWNy41TDEyIDExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassEmpty = createIcon('HourglassEmpty', [
  [
    'path',
    {
      d: 'M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5ZM12 11.5L8 7.5V4H16V7.5L12 11.5Z',
      key: '1b9d0t',
    },
  ],
]);

export default HourglassEmpty;
